import React, { lazy, useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import Drawer from '../../../../theme/components/Drawer/Drawer';
import { useI18n } from '../../../../lib/hook/useI18n';
import { renderLazyComponent } from '../../../../utils/helpers';
import { RoomConversationProps } from './RoomConversationPropsType';

const LazyRoomConversation = renderLazyComponent(
  lazy(() => import('./RoomConversation'))
);

export interface RoomConversationDialogProps extends RoomConversationProps {
  drawerHeader?: React.ReactNode;
  onClose: () => void;
  open: boolean;
}

const RoomConversationDialog: React.FC<RoomConversationDialogProps> = (
  props: RoomConversationDialogProps
): JSX.Element => {
  const { t } = useI18n();

  const { drawerHeader, onClose, open, ...RoomConversationProps } = props;

  const [conversationSize, setConversationSize] = useState(0);

  return (
    <Drawer
      anchor="right"
      disableEnforceFocus
      onClose={onClose}
      open={open}
      showCloseButton
      stickyHeader={drawerHeader}
      title={
        <Box display="flex" pb={1}>
          <Typography color="textPrimary" variant="h5">
            {t('conversation.drawer.title')}
          </Typography>
          <Chip label={conversationSize} style={{ marginLeft: 8 }} />
        </Box>
      }
      titlePaddingBottom={1}
    >
      <LazyRoomConversation
        conversationSize={conversationSize}
        setConversationSize={setConversationSize}
        {...RoomConversationProps}
      />
    </Drawer>
  );
};

export default RoomConversationDialog;
